  import { LuSearch } from "react-icons/lu";

  export default {
    row1: [
      {
        column: "column1",
        columnWidth: "95%",
        rows: {
          row1: [
            {
              name: "underSction46",
              checkboxLabel: "Under Section 46",
              component: "checkboxbox",
              sx: {
                width: "250px",
              },
            },
            {
              name: "undersection46Details",
              component: "text-field",
              width: "700px",
              gap:false

            },
          ],
          row2: [
            {
              name: "check",
              checkboxLabel: "First Check",
              component: "checkboxbox",
              sx: {
                width: "250px",
              },
            },
            {
              name: "checker",
              component: "text-field",
              width: "700px",
              gap:false

            },
          ],
          row3: [
            {
              name: "greenChannel",
              checkboxLabel: "Green Channel",
              component: "checkboxbox",
              sx: {
                width: "250px",
              },
            },
            {
              name: "channel",
              component: "text-field",
              width: "700px",
              gap:false

            },
          ],
          row4: [
            {
              name: "kachha",
              checkboxLabel: "Kachha B/E",
              component: "checkboxbox",
              sx: {
                width: "250px",
              },
            },
            {
              name: "kachhaDetails",
              component: "text-field",
              width: "700px",
              gap:false

            },
          ],
          row5: [
            {
              name: "usersec48",
              checkboxLabel: "Under Sec 48",
              component: "checkboxbox",
              sx: {
                width: "250px",
              },
            },
            {
              name: "underSec48Details",
              component: "text-field",
              width: "700px",
              gap:false

            },
          ],
          row6: [
            {
              name: "provisionalAssessment",
              checkboxLabel: "Provisional Assessment",
              component: "checkboxbox",
              sx: {
                width: "250px",
              },
            },
            {
              name: "provisionalAssessmentDetails",
              component: "text-field",
              width: "700px",
              gap:false

            },
          ],
        },
      },
    ],
  };
//           )}